import React, { useEffect, useRef } from "react";
import Navbar from "../../Navigation/Navbar";
import Footer from "../../Footer/Footer";
import product1 from '../../../images/Product/SR07.png';
import product2 from '../../../images/Product/SR07-1.png';
import product3 from '../../../images/Product/SR07-2.png';
import product4 from '../../../images/Product/SR12.png';
import product5 from '../../../images/Product/SR12-1.png';
import product6 from '../../../images/Product/SR21.png';
import product7 from '../../../images/Product/SR21-1.png';
import product8 from '../../../images/Product/SR31.png';
import product9 from '../../../images/Product/SR31-1.png';
import product10 from '../../../images/Product/SR31-2.png';
import Features from "../../../Features/Features";
import { motion } from "framer-motion";
import pointOfSales from './PointofSale';

const products = [
  {
    id: 1,
    img: [product8, product9, product10],
    title: "SR31 B&C - Famille Apollo",
    description: "Apollo 12 -- Suggère de faire fonctionner uniquement la TV ou uniquement le ventilateur.",
    specifications: [
      "1pc 40W panneau solaire avec 5M de câble",
      "1pc boitier de contrôle avec 12.8V 12AhLiFePO4 batterie",
      "3pcs 3W ampoules led a luminosité unique avec 5m de câble",
      "Avec radio",
      "Avec torche",
      "Ventilateur 16'DC (sans, optionnel)",
      "TV (sans, optionnel)"

    ]
  },
  {
    id: 2,
    img: [product6, product7],
    title: "SR24C EcoBox",
    description: "Compatible avec PAYGO.",
    specifications: [
      "1 panneau solaire 15W avec 5M de câble",
      "1 boiter de contrôle avec batterie 6.4V 6Ah LiFePO4",
      "3 ampoules LED 1W avec 5m de câble",
      "Avec radio",
      "Avec torche"

    ]
  },
  {
    id: 3,
    img: [product4, product5],
    title: "SR12A Lanterne WeLite",
    description: "Lanterne solaire avec ampoule supplémentaire et chargeur de téléphone.",
    specifications: [
      "Panneau solaire 5W",
      "Batterie LiFePO4 3.2V 6Ah",
      "1pcs 3.2V 600mah pour la torche",
      "Torche télécommandée avec lampe",
      "1pcs câble de charge cinq en un",
      "1pcs ampoule led 1W avec câble de 5M"
    ]
  },
  {
    id: 4,
    img: [product1, product2, product3],
    title: "SR07 Lampe solaire",
    description: "Lampe de lecture solaire.",
    specifications: [
      "Remplace toutes les bougies et lanternes",
      "Avec une large couverture lumineuse",
      "Avec un crochet",
      "Batterie LiFePO4 3.2V 400mAh Panneau solaire 0.3W fonctionne pendant 3-7 heures"

    ]
  }
];
// Update ProductCarousel component to allow arrow navigation for multiple images
const ProductCarousel = ({ images, title }) => {
  const carouselRef = useRef(null);
  const scrollLeft = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: -300, behavior: "smooth" });
    }
  };
  const scrollRight = () => {
    if (carouselRef.current) {
      carouselRef.current.scrollBy({ left: 300, behavior: "smooth" });
    }
  };
  return (
    <div className="relative">
      <div ref={carouselRef} className="flex overflow-x-auto scroll-smooth">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`${title} ${index + 1}`}
            className="w-full h-56 object-cover md:h-full flex-shrink-0"
          />
        ))}
      </div>
      <button
        onClick={scrollLeft}
        className="absolute left-2 top-1/2 transform -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full"
      >
        &#8592;
      </button>
      <button
        onClick={scrollRight}
        className="absolute right-2 top-1/2 transform -translate-y-1/2 bg-gray-800 bg-opacity-50 text-white p-2 rounded-full"
      >
        &#8594;
      </button>
    </div>
  );
};

const Services = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <div className="max-w-screen overflow-hidden font-poppins">
        <div className="sm:mt-36 mt-24">
          <h1 className="flex justify-center text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-emerald-500 font-extrabold sm:text-7xl text-5xl text-center drop-shadow-lg">
            Nos Produits
          </h1>
        </div>
        {/* Product View Section - render each product as a card */}
        <section className="flex flex-col gap-4 py-8">
          {products.map(product => (
            <motion.div
              key={product.id}
              className="bg-white border border-gray-200 rounded-3xl shadow-md overflow-hidden flex flex-col md:flex-row-reverse transform transition duration-500 ease-in-out hover:shadow-2xl"
            >
              <div className="md:w-1/2 w-full">
                <ProductCarousel images={product.img} title={product.title} />
              </div>
              <div className="p-6 flex-1 flex flex-col justify-center">
                <h2 className="text-2xl font-extrabold text-gray-800 mb-4">{product.title}</h2>
                <p className="text-gray-600 mb-4">{product.description}</p>
                <ul className="mb-4 space-y-1">
                  {product.specifications.map((spec, index) => (
                    <li key={index} className="text-sm text-gray-600">• {spec}</li>
                  ))}
                </ul>
              </div>
            </motion.div>
          ))}
        </section>
        <div className="w-[70%] h-[2px] bg-gradient-to-r from-blue-400 to-violet-500"></div>
        <br className="md:block hidden" />
        <br/>
        <h1 className="xl:text-5xl md:text-4xl text-2xl font-semibold leading-tight text-center text-gray-800 sm:mb-0 mb-12">
          Points de vente de l'ETS ROSE
        </h1>
        <div className="xl:px-20 px-6 py-15 xl:mx-auto xl:container grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {pointOfSales[0].sales_points.map((pos, index) => (
            <motion.div
              key={index}
              className="bg-white border border-gray-200 rounded-3xl shadow-md overflow-hidden flex flex-col transform transition duration-500 ease-in-out hover:shadow-2xl"
            >
              <div className="p-6 flex-1 flex flex-col justify-center">
                <h2 className="text-2xl font-extrabold text-gray-800 mb-4">{pos.location}</h2>
                <p className="text-gray-600 mb-4">{pos.sales_type}</p>
                <ul className="mb-4 space-y-1">
                  <li className="text-sm text-gray-600">• Province: {pos.province}</li>
                  <li className="text-sm text-gray-600">• Commune: {pos.commune}</li>
                  <li className="text-sm text-gray-600">• Quartier/Colline: {pos.quarter_hill}</li>
                  <li className="text-sm text-gray-600">• Sous-colline: {pos.sub_hill ? pos.sub_hill : "aucun"}</li>
                  <li className="text-sm text-gray-600">• Personne de contact: {pos.contact_person}</li>
                  <li className="text-sm text-gray-600">• Contact: {pos.contact}</li>
                </ul>
              </div>
            </motion.div>
          ))}
        </div>
          <br/>
        <Features />
      </div>
      <Footer />
    </>
  );
};

export default Services;
